export class GraphQLError extends Error {}
export class ValidationError extends Error {}
export class AuthenticationError extends Error {}
export class RefreshTokenError extends Error {}
